// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import './_featured-collection.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

$(function() {

    $(".carousel--featured-collection").each(function(index, element){
        var $this = $(this);
        var unique_class = "featured-collection-instance-" + index;

        // Generate unique class for each feature collection slider
        $this.addClass(unique_class);

        // Generate unique btn classes for slider arrows
        $this.parents('.featured-collection').find(".swiper-button-prev").addClass("featured-collection-btn-prev-" + index);
        $this.parents('.featured-collection').find(".swiper-button-next").addClass("featured-collection-btn-next-" + index);

        var swiper_wrapper = document.querySelector("." + unique_class);
        var swiper_slides = swiper_wrapper.querySelectorAll('li.swiper-slide');

        if (swiper_slides.length <= 4) {
            document.querySelector(".featured-collection-btn-prev-" + index).style.display = 'none';
            document.querySelector(".featured-collection-btn-next-" + index).style.display = 'none';
        }

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".featured-collection-instance-" + index, {
            // Optional parameters
            modules: [Navigation, A11y],
            slidesPerView: 50,
            autoResize: false,
            visibilityFullFit: true,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
            // when window width is >= 680px
            680: {
                slidesPerView: 4,
                spaceBetween: 20
            },

                // when window width is >= 1023px
            1023: {
                slidesPerView: 4,
                spaceBetween: 20
            },

            // when window width is >= 1023px
            1400: {
                slidesPerView: 4,
                spaceBetween: 60
            }
            },

            // // Navigation arrows
            navigation: {
            nextEl: ".featured-collection-btn-next-" + index,
            prevEl: ".featured-collection-btn-prev-" + index
            }
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});


if (document.querySelector('.carousel--featured-collection') !== null) {

    // Optimalisation: Store the references outside the event handler:
    function checkWidth() {
        var windowsize = window.innerWidth;
        if (windowsize < 680) {
            $('.carousel--featured-collection .swiper-slide').addClass('full');
        } else {
            $('.carousel--featured-collection .swiper-slide').removeClass('full');
        }
    }

    // Execute on load
    checkWidth();

   // Bind event listener
    window.addEventListener('resize', function (){
        checkWidth();
    });
}

